
export class AuditSummaryOutputDto {

  auditId: string;
  auditStatusId: string;
  auditStageId: string;
  actionType: string;
  callingType: string;
  isWfRequired: string;
  siteId: string;


}